// modules/tenant-builder/steps/BusinessInfoStep.tsx

import React from 'react';
import { Tenant } from '../../../core/types';

interface Props {
  data: Partial<Tenant>;
  onChange: (updates: Partial<Tenant>) => void;
}

export const BusinessInfoStep: React.FC<Props> = ({ data, onChange }) => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 gap-6">
        <div className="col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Nome da Pousada/Lodge *
          </label>
          <input
            type="text"
            value={data.businessName || ''}
            onChange={(e) => onChange({ businessName: e.target.value })}
            placeholder="Ex: Pousada Sol Nascente"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-900"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Tipo de Negócio *
          </label>
          <select
            value={data.businessType || ''}
            onChange={(e) => onChange({ businessType: e.target.value as any })}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 text-gray-900"
            aria-label="Tipo de Negócio"
          >
            <option value="">Selecione...</option>
            <option value="lodge">Lodge de Pesca</option>
            <option value="hotel">Hotel/Pousada</option>
            <option value="fishing_guide">Guia de Pesca</option>
            <option value="tour_operator">Operadora de Turismo</option>
            <option value="association">Associação</option>
            <option value="fishing_pond">Pesqueiro</option>
            <option value="turma">Turma de Pesca</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Domínio (opcional)
          </label>
          <input
            type="text"
            value={data.domain || ''}
            onChange={(e) => onChange({ domain: e.target.value })}
            placeholder="Ex: pousadasol.com.br"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 text-gray-900"
          />
          <p className="text-xs text-gray-500 mt-1">
            Se não tiver, criaremos um domínio .pescar.app para você
          </p>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Email de Contato *
          </label>
          <input
            type="email"
            value={data.email || ''}
            onChange={(e) => onChange({ email: e.target.value })}
            placeholder="contato@pousada.com.br"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 text-gray-900"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Telefone/WhatsApp *
          </label>
          <input
            type="tel"
            value={data.phone || ''}
            onChange={(e) => onChange({ phone: e.target.value })}
            placeholder="(62) 99999-9999"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 text-gray-900"
          />
        </div>

        <div className="col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Slogan/Descrição Curta
          </label>
          <input
            type="text"
            value={data.slogan || ''}
            onChange={(e) => onChange({ slogan: e.target.value })}
            placeholder="Ex: A melhor experiência de pesca esportiva do Araguaia"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 text-gray-900"
          />
        </div>

        <div className="col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Descrição Completa
          </label>
          <textarea
            value={data.description || ''}
            onChange={(e) => onChange({ description: e.target.value })}
            rows={4}
            placeholder="Conte um pouco sobre sua pousada, localização, diferenciais..."
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 text-gray-900"
          />
          <div className="col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Visibilidade do Site *
          </label>
          <div className="flex gap-4">
            <label className={`flex-1 border rounded-lg p-4 cursor-pointer transition-all ${(!data.settings?.privacy || data.settings?.privacy === 'public') ? 'border-blue-500 bg-blue-50 ring-1 ring-blue-500' : 'border-gray-200 hover:border-gray-300'}`}>
              <div className="flex items-center gap-3">
                <input
                  type="radio"
                  name="privacy"
                  value="public"
                  checked={!data.settings?.privacy || data.settings?.privacy === 'public'}
                  onChange={() => onChange({ settings: { ...data.settings!, privacy: 'public' } })}
                  className="h-4 w-4 text-blue-600"
                />
                <div>
                  <span className="block font-medium text-gray-900">Público (Mundo)</span>
                  <span className="text-sm text-gray-500">Qualquer pessoa pode ver o site e ranking.</span>
                </div>
              </div>
            </label>

            <label className={`flex-1 border rounded-lg p-4 cursor-pointer transition-all ${data.settings?.privacy === 'private' ? 'border-blue-500 bg-blue-50 ring-1 ring-blue-500' : 'border-gray-200 hover:border-gray-300'}`}>
              <div className="flex items-center gap-3">
                <input
                  type="radio"
                  name="privacy"
                  value="private"
                  checked={data.settings?.privacy === 'private'}
                  onChange={() => onChange({ settings: { ...data.settings!, privacy: 'private' } })}
                  className="h-4 w-4 text-blue-600"
                />
                <div>
                  <span className="block font-medium text-gray-900">Privado (Membros)</span>
                  <span className="text-sm text-gray-500">Apenas membros logados têm acesso.</span>
                </div>
              </div>
            </label>
          </div>
        </div>
      </div>
      </div>
      
      {/* Financeiro Section */}
      <div className="bg-white border rounded-lg p-6 space-y-4">
         <h3 className="font-bold text-gray-800 flex items-center gap-2">
            <span className="text-green-600">💲</span> Dados para Recebimento (Pix)
         </h3>
         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
             <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Chave Pix</label>
                <input 
                  type="text" 
                  value={data.finance?.pixKey || ''} 
                  onChange={(e) => onChange({ finance: { ...data.finance, pixKey: e.target.value, pixName: data.finance?.pixName || '', pixKeyType: 'random' } })}
                  placeholder="Ex: 00.000.000/0001-00"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg"
                />
             </div>
             <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Nome do Favorecido</label>
                <input 
                  type="text" 
                  value={data.finance?.pixName || ''} 
                  onChange={(e) => onChange({ finance: { ...data.finance, pixName: e.target.value, pixKey: data.finance?.pixKey || '', pixKeyType: 'random' } })}
                  placeholder="Ex: Pousada Exemplo LTDA"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg"
                />
             </div>
         </div>
         <p className="text-xs text-gray-500">Esses dados aparecerão automaticamente nos orçamentos PDF/Web.</p>
      </div>

      <div className="bg-white border rounded-lg p-6 space-y-4">
         <h3 className="font-bold text-gray-800 flex items-center gap-2">
            <span className="text-green-600">💲</span> Dados para Recebimento (Pix)
         </h3>
         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
             <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Chave Pix</label>
                <input 
                  type="text" 
                  value={data.finance?.pixKey || ''} 
                  onChange={(e) => onChange({ finance: { ...data.finance, pixKey: e.target.value, pixName: data.finance?.pixName || '', pixKeyType: 'random' } })}
                  placeholder="Ex: 00.000.000/0001-00"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg"
                />
             </div>
             <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Nome do Favorecido</label>
                <input 
                  type="text" 
                  value={data.finance?.pixName || ''} 
                  onChange={(e) => onChange({ finance: { ...data.finance, pixName: e.target.value, pixKey: data.finance?.pixKey || '', pixKeyType: 'random' } })}
                  placeholder="Ex: Pousada Exemplo LTDA"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg"
                />
             </div>
         </div>
         <p className="text-xs text-gray-500">Esses dados aparecerão automaticamente nos orçamentos PDF/Web.</p>
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <p className="text-sm text-blue-800">
          💡 <strong>Dica:</strong> Essas informações podem ser editadas depois no painel administrativo
        </p>
      </div>
    </div>
  );
};
